export class MainMenuTab {
    constructor(
        public readonly key: string,
        public readonly onClick: Function,
        public readonly iconClass: string,
        public readonly captureId: string,
        public readonly url: string = null,
        public isSelected: boolean = false
    ) {}
}
